<ptl-v3-filter-shell [title]="'translations.filter.activity.name' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <div shell-controls class="v3-activity-date-filter__controls">
    <ptl-select class="v3-activity-date-filter__select" [options]="activityIsOptions" [(ngModel)]="activityIs"></ptl-select>
    <span class="v3-activity-date-filter__label">{{ 'translations.filter.activity.beenActive' | transloco }}</span>
    <ptl-select class="v3-activity-date-filter__select" [options]="filterTypeOptions" [(ngModel)]="filterType"></ptl-select>
  </div>

  @if (filterType === 'SINCE') {
    <div class="v3-activity-date-filter__row">
      <ptl-date-input class="v3-activity-date-filter__date" [value]="sinceDateValue" (valueChange)="onSinceDateChange($event)">
      </ptl-date-input>
    </div>
  }

  @if (filterType === 'FOR_THE_LAST') {
    <div class="v3-activity-date-filter__row">
      <input
        class="v3-activity-date-filter__quantity"
        type="number"
        min="1"
        [attr.aria-label]="'translations.global.ariaLabels.enterTicketsQuantity' | transloco"
        [(ngModel)]="quantity"
      />
      <ptl-select class="v3-activity-date-filter__period" [options]="periodTypeOptions" [(ngModel)]="periodType"></ptl-select>
    </div>
  }

  @if (filterType === 'IN_RANGE') {
    <div class="v3-activity-date-filter__row">
      <ptl-date-input
        class="v3-activity-date-filter__date"
        [value]="startDateValue"
        [max]="endDateValue || null"
        (valueChange)="onStartDateChange($event)"
      >
      </ptl-date-input>
      <span class="v3-activity-date-filter__range-separator" aria-hidden="true">&ndash;</span>
      <ptl-date-input
        class="v3-activity-date-filter__date"
        [value]="endDateValue"
        [min]="startDateValue || null"
        (valueChange)="onEndDateChange($event)"
      >
      </ptl-date-input>
    </div>
  }
</ptl-v3-filter-shell>
